import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../../Config";
import { IoCopySharp } from "react-icons/io5";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../../helpers";

const Table = ({
  apiData,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const storageKey = `landlord_expiring_page`;
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  //const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);

  // Load saved page index
  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  // useEffect(() => {
  //   setCurrentPage(0);
  // }, [apiData]);

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        rent: <Amount>{'₹' + item.rent}</Amount>,
        security: <AmountSecurity>{'₹' + item.security}</AmountSecurity>,
        property: getProperty(item),//item?.propertyName ? truncateText(item.propertyName, 25) : 'NA',
        //expiryDate: moment(item.endDate).format('DD, MMM YYYY'),
        expiryDate: <ExpiryBadge date={item.endDate} />,
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getName = (item) => {
    const name = capitalizeFirstLetter(item?.landlordName || "N/A");

    return (
      <UserImageWrapper>
        <UserImage src={item.profilePicture || Images.Avatar} alt={name} />

        <div className="flex flex-col min-w-0">
          <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">
            {name}
          </span>

          <div className="flex items-center gap-1 text-xs text-gray-400">
            <span>#{item.landlordMobile}</span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleCopy(item.landlordMobile);
              }}
              className="hover:text-gray-600 transition"
              title="Copy number"
            >
              <IoCopySharp size={12} />
            </button>
          </div>
        </div>
      </UserImageWrapper>
    );
  };

  const getProperty = (item) => {
    const propertyName = capitalizeFirstLetter(item?.propertyName || 'N/A');
    const flatName = item?.flatName
      ? `Flat ${item.flatName}`
      : null;

    return (
      <div className="flex flex-col max-w-[220px]">
        <span className="text-sm text-gray-900 truncate">
          {propertyName}
        </span>

        {flatName ? (
          <div className="mt-1">
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600 border border-gray-200">
              {flatName}
            </span>
          </div>
        ) : (
          null
        )}
      </div>
    );
  };

  const ExpiryBadge = ({ date }) => {
    const daysLeft = moment(date).diff(moment(), "days");

    const base =
      "px-3 py-1 rounded-full text-xs font-semibold inline-flex";

    if (daysLeft < 0)
      return <span className={`${base} bg-rose-100 text-rose-700`}>Expired</span>;

    if (daysLeft <= 30)
      return <span className={`${base} bg-amber-100 text-amber-700`}>
        {daysLeft} days left
      </span>;

    return (
      <span className={`${base} bg-green-100 text-green-700`}>
        {moment(date).format("DD MMM YYYY")}
      </span>
    );
  };


  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Landlord",
          accessor: "name",
        },
        {
          Header: "Property",
          accessor: "property",
        },
      ];
    }
    return [
      {
        Header: "Landlord",
        accessor: "name",
      },
      {
        Header: "Property",
        accessor: "property",
      },
      {
        Header: "Rent",
        accessor: "rent",
      },
      {
        Header: "Security",
        accessor: "security",
      },

      {
        Header: "Agmt End",
        accessor: "expiryDate",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    //setCurrentPage(pageIndex);
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            const rowData = apiData[rowIndex];
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps({ style: { height: "80px" } })}
                  hasdata={(apiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    const isActionCell = cell.column.id === "action";
                    return (
                      <Td
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Security</strong>{" "}
                          {data[rowIndex].security}
                        </li>
                        <li>
                          <strong>Expiry Date</strong>{" "}
                          {data[rowIndex].expiryDate}
                        </li>

                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}

    </>
  );
};

const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
//const Amount = tw.p`text-gray-600 text-sm flex bg-amber-100 px-3 py-1 rounded-md inline-flex`
//const AmountSecurity = tw.p`text-gray-600 text-sm flex bg-neutral-100 px-3 py-1 rounded-md inline-flex`
const Amount = tw.p`
  bg-amber-50 text-amber-800
  text-sm font-medium
  px-3 py-1
  rounded-full inline-flex
`;

const AmountSecurity = tw.p`
  bg-slate-100 text-slate-700
  text-sm font-medium
  px-3 py-1
  rounded-full inline-flex
`;


export default Table;
